import LongTermCareAndNurse from './LongTermCareAndNurse';

export default LongTermCareAndNurse;
